/*This is minimal change for signUp while creating
patients record i.e email in patients table*/
/*import axios from "axios";
import keycloak from "./keycloak";

//process.env.REACT_APP_API_BASE_URL ||
const API_BASE_URL = "http://localhost:8080";
const PATIENTS_BASE_URL = `${API_BASE_URL}/api/v1/patients`;

function hasRole(role) {
  // Keycloak adapters often expose one of these shapes
  const realmRoles = keycloak?.realmAccess?.roles || [];
  const tokenRealmRoles = keycloak?.tokenParsed?.realm_access?.roles || [];
  const resourceRoles =
    keycloak?.resourceAccess &&
    Object.values(keycloak.resourceAccess).flatMap((r) => r?.roles || []);

  return (
    realmRoles.includes(role) ||
    tokenRealmRoles.includes(role) ||
    resourceRoles.includes(role)
  );
}

// NEW: helper to call minimal-signup (PATIENT only)
async function callMinimalSignupIfPossible() {
  if (!keycloak || !keycloak.token) return;

  // ✅ only patients should ever hit this endpoint
  if (!hasRole("PATIENT")) return;


  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${keycloak.token}`,
  };

  // Use email from token if available (matches your BE fallback logic)
  const emailFromToken = keycloak.tokenParsed?.email || null;
  const body = emailFromToken ? { email: emailFromToken } : {};

  try {
    await axios.post(`${PATIENTS_BASE_URL}/minimal-signup`, body, { headers });
  } catch (error) {
    const status = error?.response?.status;

    // ✅ non-fatal: already exists
    if (status === 409) {
      return;
    }

    // ✅ non-fatal: auth/role mismatch; /me will be the authority anyway
    if (status === 401 || status === 403) {
      return;
    }

    // ⚠️ anything else is worth seeing, but still don't block /me
    console.error(
      "Minimal signup failed:",
      status,
      error?.response?.data || error,
    );
  }
}

export async function fetchCurrentUser() {

  try {
    const headers = { Accept: "application/json" };

    if (keycloak?.token) {
      headers.Authorization = `Bearer ${keycloak.token}`;
      await callMinimalSignupIfPossible();
    }

    const response = await axios.get(`${API_BASE_URL}/me`, { headers });
    return response.data;
  } catch (error) {
    const status = error?.response?.status;

    if (status === 401 || status === 403) return null;

    if (!error.response) {
        "Network/CORS issue fetching /me, treating as unauthenticated:",
        error,
      );
      return null;
    }

    console.error("Failed to fetch /me:", error);
    throw new Error("Unable to fetch current user");
  }
}*/

import api from "./axios";
import keycloak from "./keycloak";

function hasRole(role) {
  const realmRoles = keycloak?.realmAccess?.roles || [];
  const tokenRealmRoles = keycloak?.tokenParsed?.realm_access?.roles || [];
  const resourceRoles =
    keycloak?.resourceAccess &&
    Object.values(keycloak.resourceAccess).flatMap((r) => r?.roles || []);

  return (
    realmRoles.includes(role) ||
    tokenRealmRoles.includes(role) ||
    resourceRoles.includes(role)
  );
}

async function callMinimalSignupIfPossible() {
  if (!keycloak || !keycloak.authenticated) return;
  if (!hasRole("PATIENT")) return;

  const emailFromToken = keycloak.tokenParsed?.email || null;
  const body = emailFromToken ? { email: emailFromToken } : {};

  try {
    await api.post("/api/v1/patients/minimal-signup", body);
  } catch (error) {
    const status = error?.response?.status;
    if (status === 409) return; // already exists, non-fatal
    if (status === 401 || status === 403) return; // auth mismatch, non-fatal
    console.error(
      "Minimal signup failed:",
      status,
      error?.response?.data || error,
    );
  }
}

export async function fetchCurrentUser() {
  if (!keycloak?.authenticated || !keycloak?.token) {
    return null;
  }

  try {
    await callMinimalSignupIfPossible();
    const response = await api.get("/api/v1/me");
    return response.data;
  } catch (error) {
    const status = error?.response?.status;

    if (status === 401 || status === 403) {
      // Token refresh already failed in the interceptor — session is dead
      const err = new Error("Session expired");
      err.sessionExpired = true;
      throw err;
    }

    if (!error.response) {
      return null;
    }

    throw new Error("Unable to fetch current user");
  }
}

/*
export async function fetchCurrentUser() {
  // ✅ Guard: don't call /me if not authenticated
  if (!keycloak?.authenticated || !keycloak?.token) {
    return null;
  }


  try {
    const headers = {
      Accept: "application/json",
      Authorization: `Bearer ${keycloak.token}`,
    };

    // Call minimal-signup first for patients
    await callMinimalSignupIfPossible();

    const response = await axios.get(`${API_BASE_URL}/me`, { headers });
    return response.data;
  } catch (error) {
    const status = error?.response?.status;

    if (status === 401 || status === 403) {
      return null;
    }

    if (!error.response) {
      return null;
    }

    console.error("❌ Failed to fetch /me:", error);
    throw new Error("Unable to fetch current user");
  }
}*/
